import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMapPin: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="map-pin, location">
      <path
        d="M14.4978 10C14.4978 11.3807 13.3785 12.5 11.9978 12.5C10.6171 12.5 9.4978 11.3807 9.4978 10C9.4978 8.61929 10.6171 7.5 11.9978 7.5C13.3785 7.5 14.4978 8.61929 14.4978 10Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M19 10C19 15.866 12 21 12 21C12 21 5 15.866 5 10C5 6.13401 8.13401 3 12 3C15.866 3 19 6.13401 19 10Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </CentralIconBase>
  );
};

export default IconMapPin;
